"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBuilderStepItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const stepper_1 = require("@pulse-web-ui/stepper");
const rules = {
    validate: (value) => Boolean(value === null || value === void 0 ? void 0 : value.isValid),
};
exports.FormBuilderStepItem = (0, react_1.memo)((formBuilderStepItemProps) => {
    const myRef = (0, react_1.useRef)(null);
    const { component: { component: Component, props }, activeStep, control, isSubmitting, setRef, isSmartComponentsShowing, debugMode, } = formBuilderStepItemProps;
    const render = (0, react_1.useCallback)(({ field: { onChange, value, name }, fieldState }) => {
        const handleChange = (0, react_1.useCallback)((data) => {
            if (debugMode)
                console.log(`smart component {${name}} onChange called`, data);
            onChange(data);
        }, []);
        return ((0, jsx_runtime_1.jsx)(Component, { onChange: handleChange, value: value, name: name, ref: myRef, fieldState: fieldState, isSubmitting: isSubmitting, options: props.options }, props.id));
    }, [isSubmitting, props.id]);
    (0, react_1.useEffect)(() => {
        if (myRef === null || myRef === void 0 ? void 0 : myRef.current)
            setRef(myRef.current, props.name);
    }, [props.name]);
    if (!isSmartComponentsShowing)
        return;
    return ((0, jsx_runtime_1.jsx)(stepper_1.StepPanel, { value: activeStep, index: activeStep, children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { rules: rules, render: render, name: props.id, control: control }) }, `${activeStep}${props.id}`));
});
exports.FormBuilderStepItem.displayName = 'FormBuilderStepItem';
